import UserService from './services/User';
import UserLoginUseCase from './use-cases/UserLogin';
import AbstractModuleFactory from '@core/shared/module-factory';
import { BasicAuthenticationUseCase, IUserService } from './types';
import AddNewServiceForUsreUseCase from './use-cases/UserAddNewService';
import DownloadUserDocPdfUseCase from './use-cases/DownloadUserDocPdf';
import GetUserDashboardInfoUseCase from './use-cases/UserDashboardInfo';
import GetUserProfileUseCase, { IGetUserProfileUseCase } from './use-cases/GetUserProfile';
import GetAllContractUseCase, { IGetAllContractUseCase } from '@core/domain/Contract/use-cases/GetAllContracts';
import GetAllInvoiceUseCase ,{IGetAllInvoiceUseCase} from '../Invoice/use-cases/GetAllInvoices';
import UserSessionRespositoryFactory, { IUserSessionRespository } from '@infrastructure/persistance/user-session';

/**
 * ### User module dependency factory.
 * Abstract Factory that create instance for all
 * use cases.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
export class UserModuleFactory extends AbstractModuleFactory {
  createLoginUserCase(): BasicAuthenticationUseCase {
    const sessionRepo: IUserSessionRespository = UserSessionRespositoryFactory.createLocalUserSessionRepository();
    return this.ensureInstance('UserLoginUseCase', () => new UserLoginUseCase(sessionRepo));
  }

  creatUserDashboardInfoUseCase(): GetUserDashboardInfoUseCase {
    const userService: IUserService = new UserService();
    const getAllContracts: IGetAllContractUseCase = new GetAllContractUseCase();
    const getAllInvoices: IGetAllInvoiceUseCase = new GetAllInvoiceUseCase();
    return this.ensureInstance('GetUserDashboardInfoUseCase', () => new GetUserDashboardInfoUseCase(userService, getAllContracts,getAllInvoices));
  }

  createAddNewServiceForUserUseCase(): AddNewServiceForUsreUseCase {
    return this.ensureInstance('AddNewServiceForUsreUseCase', () => new AddNewServiceForUsreUseCase());
  }

  createGetUserProfileUseCase(): IGetUserProfileUseCase {
    const sessionRepo: IUserSessionRespository = UserSessionRespositoryFactory.createLocalUserSessionRepository();
    return this.ensureInstance('GetUserProfileUseCase', () => new GetUserProfileUseCase(sessionRepo));
  }

  createDownloadUserDocPdfUseCase(): DownloadUserDocPdfUseCase {
    return this.ensureInstance('DownloadUserDocPdfUseCase', () => new DownloadUserDocPdfUseCase());
  }

  static new(): UserModuleFactory {
    return new UserModuleFactory();
  }
}

export default UserModuleFactory.new();
